import Head from "next/head";
import Footer from "../components/Footer";
import Script from "next/script";
import Image from "next/image";
import CTA from "../components/landingpage/CTA";
import Navbar from "../components/Navbar";
import Link from "next/link";

const Contact = () => {
  return (
    <>
      <Navbar />
      <Head>
        <title>ocena | Contact</title>
        <link rel="icon" href="/assets/favicon.ico" />
      </Head>
      {/* <Script src="/static/ChannelTalk.js" /> */}
      <div className="h-100% bg-zinc-100">
        <div className="mx-auto max-w-[72rem] py-20 px-8 md:justify-between lg:flex lg:space-x-14">
          <div className="flex max-w-sm flex-col justify-between lg:mt-16">
            <div>
              <h1 className="whitespace-nowrap text-4xl font-bold leading-snug text-zinc-700 sm:text-[2.75rem] xl:text-5xl xl:leading-normal ">
                문의하기
              </h1>
              <p className=" mt-8 whitespace-normal text-base leading-relaxed text-zinc-600 ">
                안녕하세요 오세나 팀입니다. 문의 내용을 남겨주시면 최대한 빠르게
                답변 드리도록 하겠습니다. 감사합니다.
              </p>
            </div>
            <div className="mt-8 rounded-3xl border-2 border-zinc-200 bg-white p-6 transition-all">
              <p className="text-xl font-bold text-zinc-700">
                오세나의 정식 프로덕트가 <br className=" sm:hidden" />곧
                출시됩니다!
              </p>
              <Link href="/launch">
                <button className="group mt-4 flex items-center space-x-2 font-medium hover:space-x-3  ">
                  <p className=" underline decoration-primary/60 decoration-[3px] underline-offset-4 transition-all group-hover:no-underline">
                    사전신청하기
                  </p>
                  <span className="no-underline  transition-all">→</span>
                </button>
              </Link>
            </div>
          </div>

          <form
            action="https://formsubmit.co/contact@ocena.app"
            method="POST"
            className="mt-8 w-full space-y-6 rounded-3xl  border-[3px] border-zinc-500 bg-white px-8 py-8 md:min-w-[30rem] lg:mt-0 lg:max-w-xl"
          >
            <input
              type="hidden"
              id="페이지"
              name="페이지"
              value="문의하기"
            ></input>
            <div>
              <label className="mb-2 block text-sm font-medium text-zinc-500">
                이름*
              </label>
              <input
                type="text"
                name="이름"
                id="이름"
                className=" block w-full rounded-xl border-2 border-zinc-300 p-3 text-sm  "
                placeholder="이름을 입력해주세요"
                required
              />
            </div>
            <div>
              <label className="mb-2 block text-sm font-medium text-zinc-500">
                기업*
              </label>
              <input
                type="text"
                name="기업"
                id="기업"
                className=" block w-full rounded-xl border-2 border-zinc-300 p-3 text-sm  "
                placeholder="기업명 입력해주세요"
                required
              />
            </div>
            <div>
              <label className="mb-2 block text-sm font-medium text-zinc-500">
                이메일*
              </label>
              <input
                type="email"
                name="email"
                id="email"
                className=" block w-full rounded-xl border-2 border-zinc-300 p-3 text-sm  "
                placeholder="name@example.com"
                required
              />
            </div>

            <div className="sm:col-span-2">
              <label className="mb-2 block text-sm font-medium text-zinc-500">
                문의 내용
              </label>
              <textarea
                id="message"
                name="문의 내용"
                rows="6"
                className=" block w-full rounded-xl border-2 border-zinc-300 p-3 text-sm "
                placeholder="문의사항을 입력해주세요"
              ></textarea>
            </div>
            <div className="flex w-full justify-center">
              <button
                type="submit"
                className="rounded-full bg-primary/90 px-6 py-5 text-center text-sm font-bold text-white hover:outline hover:outline-2 hover:outline-offset-2 hover:outline-primary/40 focus:bg-primary"
              >
                문의 보내기
              </button>
            </div>
          </form>
        </div>
        {/* <div className="mx-auto max-w-[72rem] pb-16">
          <CTA />
        </div> */}
      </div>
      <Footer />
    </>
  );
};

export default Contact;
